import React from 'react';
import { motion } from 'framer-motion';
export function BundleShowcase() {
  return <section className="py-16 md:py-20 px-6 bg-cream-light bg-noise overflow-hidden" data-id="element-160">
      <div className="max-w-6xl mx-auto" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-10" data-id="element-162">
          <p className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-4" data-id="element-163">
            El Sistema Completo
          </p>
          <h2 className="text-3xl md:text-5xl font-serif text-charcoal" data-id="element-164">
            Todo lo que llevás{' '}
            <span className="italic text-olive" data-id="element-165">en una sola compra</span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9
      }} className="relative rounded-3xl overflow-hidden shadow-2xl border border-gold/20" data-id="element-166">
          <img src="https://cdn.magicpatterns.com/uploads/9Wsr6uVseWm3T9qGD2Rw5A/BUNDLE_2.png" alt="Sistema Wellaging Argentino - Ebook Principal + 4 Bonuses" className="w-full h-auto block" data-id="element-167" />
        </motion.div>
      </div>
    </section>;
}